export default __webpack_public_path__ + "static/media/KaoruTanaka-1.2ETHM.901aa9a0.mp4";